$ const {
  value,
  min = 1,
  max = 200,
  step = 1,
  unit = "km",
  label = "Max. distance",
} = input;
$ const numericValue = value ? parseInt(value, 10) : min;
$ const displayValue = `${numericValue} ${unit}`;
$ const progress = ((numericValue - min) / (max - min)) * 100;
$ const isMinDisabled = numericValue <= min;
$ const isMaxDisabled = numericValue >= max;

<div class="map-distance-slider">
  <div class="map-distance-slider__header">
    <span class="map-distance-slider__label">
      ${label}
    </span>
    <span class="map-distance-slider__value" data-testid="map-distance-slider-value">
      ${displayValue}
    </span>
  </div>

  <div class="map-distance-slider__controls">
    <ebay-icon-button data-testid="map-distance-slider-minus" on-click("handleDecrement") disabled=isMinDisabled>
      <ebay-remove-16-icon/>
    </ebay-icon-button>

    <div class="map-distance-slider__track-container">
      <input
        type="range"
        class="map-distance-slider__track"
        data-testid="map-distance-slider-input"
        min=min
        max=max
        step=step
        value=numericValue
        on-input("handleSliderChange")
        style=`--slider-progress: ${progress}%`
      >
    </div>

    <ebay-icon-button data-testid="map-distance-slider-plus" on-click("handleIncrement") disabled=isMaxDisabled>
      <ebay-add-16-icon/>
    </ebay-icon-button>
  </div>

  <div class="map-distance-slider__labels">
    <span class="map-distance-slider__label-min">
      ${min} ${unit}
    </span>
    <span class="map-distance-slider__label-max">
      ${max} ${unit}
    </span>
  </div>
</div>
